module.exports = __webpack_public_path__ + "img/Logo.6a983e48.svg";